<div class="full-width-header header-style1 home8-style4">
  <main-menu></main-menu>
</div>

<!-- Main content Start -->
<div class="main-content">
  <div class="rs-breadcrumbs breadcrumbs-overlay">
    <div class="breadcrumbs-img">
      <img src="assets/images/breadcrumbs/2.jpg" alt="Breadcrumbs Image">
    </div>
    <div class="breadcrumbs-text white-color">
      <h1 class="page-title">Institution Industry Cell</h1>
      <ul>
        <li><a class="active" routerLink="/home">Home</a></li>
        <li>Institution Industry Cell</li>
      </ul>
    </div>
  </div>

  <div class="rs-inner-blog orange-color pt-100 pb-100 md-pt-70 md-pb-70 committee-section">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-12 pr-50 md-pr-15">
          <div class="widget-area">
            <div class="widget-archives footer-widget mb-50">
              <h3 class="widget-title">Committees</h3>
              <ul>
                <li class="menu-item-has-children" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
                  <ul class="sub-menu">
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/anti-ragging-committee">Anti Ragging Committee</a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/grievance-reddressal-committee">Grievance Reddressal Committee</a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/internal-complaints-committee">Internal Complaints Committee</a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/sc-and-st-grievance-committee">SC &amp; ST Grievance Committee</a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/internal-quality-assurance-committee">Internal Quality Assurance Committee</a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/institution-industry-cell">Institution Industry Cell</a></li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-lg-8">
          <div class="committee-content-wrap">
            <h2 class="committee-main-title">Institution Industry Cell</h2>

            <h3 class="committee-sub-title">OBJECTIVES</h3>

            <ol class="content-list">
              <li>To synchronize the quality of education to meet the current trends and needs of industry.</li>
              <li>To produce employable students i.e., “Industry-Ready students.”</li>
              <li>To create adequate facilities for upgrading knowledge of professional engineers and technologists to meet the growth and developmental needs of the current industry.</li>
              <li>To integrate industrial training and other inputs to develop students.</li>
              <li>To share the experience and expertise between institutions and industry for mutual benefits.</li>
              <li>To improve students, faculty, infrastructure, pedagogy in line with the industry's requirements.</li>
              <li>To arrange industrial visit, internships for students and guest faculty from industry experts.</li>
            </ol>

            <h3 class="committee-sub-title">FUNCTIONS</h3>

            <ol class="content-list">
              <li>College/Industry Institute Interaction cell continuously encourage students to undergo internship during semester vacation to synchronize the quality of education to meet the current trends and needs of industry</li>
              <li>To arrange the guest lectures by experts from industry frequently to make the students familiar with latest industrial practices so that they become “Industry-Ready students.</li>
              <li>To organize the industrial visits for students and staff to learn the latest industrial practices.</li>
              <li>To send the students for Industrial Training Programs to train them in the latest technologies.</li>
            </ol>

            <p class="blog-table-wrap">
              <a href="/assets/college/Committees/Institution Industry Cell 2025-26.pdf" target="_blank">Institution Industry Cell (click to view)</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Newsletter section start -->
  <app-subscribe></app-subscribe>
  <!-- Newsletter section end -->
</div>
<!-- Main content End -->

